import { Grid } from "@mui/material";
import { observer } from "mobx-react";
import type ChartCardStore from "../ChartCardStore";
import AcxSelect from "components/UI/Select/BaseSelectComponents/AcxSelect";

type LLMClassifierControlProps = {
    store: ChartCardStore;
};

const LLMClassifierControl = observer(
    ({ store }: LLMClassifierControlProps) => {
        const llmOptions = store.optionsStore.llmClassifiers;

        const optionsLoading = store.optionsStore.llmClassifiersLoading;

        return (
            <Grid item xs={3}>
                <AcxSelect
                    id="select-model"
                    valueField="id"
                    labelField="name"
                    fullWidth
                    options={llmOptions}
                    defaultValue={llmOptions.find(
                        (llmClassifier) =>
                            llmClassifier.id ===
                            store.selectedIds.llmClassifier,
                    )}
                    onChange={(llmClassifier) => {
                        store.setSelectedId("llmClassifier", llmClassifier?.id);
                        store.handleSelectionChange();
                    }}
                    placeholder="Select model"
                    isLoading={optionsLoading}
                    isDisabled={store.isReadOnly}
                    disabledAppearance="readOnly"
                />
            </Grid>
        );
    },
);

export default LLMClassifierControl;
